module.exports = ".kan-membership-dialog-container {\n  font-size: 13px; }\n  .kan-membership-dialog-container .membership-history {\n    margin-bottom: 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 120px; }\n  .kan-membership-dialog-container .membership-history .row {\n      padding: 6px;\n      border-bottom: 1px solid #efefef; }\n  .kan-membership-dialog-container .membership-history .row:nth-of-type(odd) {\n        background-color: #dfdfdf; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/membership-dialog/component.scss
// module id = ./src/modules/admin/dialogs/membership-dialog/component.scss
// module chunks = main